import React from 'react';
import { DesktopHeader } from './components/Header';
import Greeting from './components/Greeting';
import { StatsSection } from './components/Stats';
import RecentInbox from './components/RecentInbox';
import UpcomingMeetings from './components/UpcomingMeetings';

const DesktopDashboard = ({
  userData,
  dashboardStats,
  statsLoading,
  statsError,
  schedule,
  meetings,
  meetingsLoading,
  calendlyConnected,
}) => {
  return (
    <>
      <DesktopHeader />

      {/* Main Content */}
      <div className="px-8 py-8 max-w-7xl mx-auto w-full overflow-y-auto flex-1">
        <Greeting userName={userData.name} />

        <StatsSection stats={dashboardStats} loading={statsLoading} error={statsError} />

        {/* Two Column Layout */}
        <div className="grid grid-cols-12 gap-8">
          <RecentInbox />
          <UpcomingMeetings
            meetings={meetings}
            loading={meetingsLoading}
            calendlyConnected={calendlyConnected}
          />
        </div>
      </div>
    </>
  );
};

export default DesktopDashboard;
